import React from 'react';
import classNames from 'classnames';
import './ResizeAdorner.less';
import { ResizeDirection } from '@decisions/server/DecisionsFramework/Design/Form/ResizeDirection';
import { SelectionAdorner, ISelectionAdornerProps } from './../SelectionAdorner/SelectionAdorner';
import { ResizeHandler } from './ResizeHandler';
import { IResizeHandlerProps } from './ResizeHandler';

export interface IResizeAdornerProps extends ISelectionAdornerProps {
  resizeDirections?: ResizeDirection[];
  handlerMouseDown: IResizeHandlerProps['onMouseDown'];
  handlerMouseUp?: (e: React.MouseEvent<HTMLElement>) => void;
}

//TODO alex: we need to support resize/moving via keyboard like in FormDesigner,
// need to add title with short cuts for every handler
/**
 * Component frame during resize operation.
 * It is supposed to be used together with "useResize" hook.
 *
 * Copyright (c) 2020 Decisions All Rights Reserved
 */
export function ResizeAdorner({
  resizeDirections,
  className,
  handlerMouseDown,
  handlerMouseUp,
  ...otherProps
}: IResizeAdornerProps) {
  const directions =
    resizeDirections == null || resizeDirections.includes(ResizeDirection.All) ? allResizeDirections : resizeDirections;
  return (
    <SelectionAdorner className={classNames('dpc-resize-adorner', className)} {...otherProps}>
      {directions.map(direction => (
        <ResizeHandler
          key={direction}
          resizeDirection={direction}
          onMouseDown={handlerMouseDown}
          onMouseUp={handlerMouseUp}
        />
      ))}
    </SelectionAdorner>
  );
}

const allResizeDirections = [
  ResizeDirection.Left | ResizeDirection.Top,
  ResizeDirection.Left,
  ResizeDirection.Left | ResizeDirection.Bottom,
  ResizeDirection.Right | ResizeDirection.Top,
  ResizeDirection.Right,
  ResizeDirection.Right | ResizeDirection.Bottom,
  ResizeDirection.Top,
  ResizeDirection.Bottom,
];
